module.exports = __webpack_public_path__ + "static/media/illuEuropraid2018_01_thumb.7605794c.png";